import { type SupportedChain } from '@pkg/types';

export function getChainFromIndex(chainIndex: 0 | 1 | 2): SupportedChain {
    switch (chainIndex) {
        case 2:
            return 'aptos';
        case 1:
            return 'polygon';
        case 0:
        default:
            return 'ethereum';
    }
}

export function getChainFromWagmiChainId(chainId: number) {
    switch (chainId) {
        case 137:
            return 'polygon';
        case 5:
        case 11_155_111:
        case 1:
            return 'ethereum';
        default:
            // TODO: find out about the about chain id
            return 'aptos';
    }
}
